import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { EntDirectoryInfoName } from "../../../../../models/directoryInfoName";
import { DraggableModal } from "../../../../../components/DraggableModal";

enum FormField {
  alias,
  nameKy,
  nameRu
}

interface IProps {
  show: boolean;
  fertilizerCategory: EntDirectoryInfoName;
  onHide: () => void;
  onSubmit: (pos: EntDirectoryInfoName) => Promise<boolean>;
}

export const AddFertilizerCategory = (props: IProps) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
	if (props.show) setFieldsFromEntity();
  }, [props.show]);

  const setFieldsFromEntity = (): void => {
	form.setFields([
	  { name: FormField.alias, value: props.fertilizerCategory.alias },
	  { name: FormField.nameKy, value: props.fertilizerCategory.nameKy },
	  { name: FormField.nameRu, value: props.fertilizerCategory.nameRu },
	]);
  }

  const setEntityFromFields = (): EntDirectoryInfoName => {
	let fertilizerCategory = _.cloneDeep(props.fertilizerCategory);
	fertilizerCategory.alias = form.getFieldValue(FormField.alias);
	fertilizerCategory.nameKy = form.getFieldValue(FormField.nameKy);
	fertilizerCategory.nameRu = form.getFieldValue(FormField.nameRu);
	return fertilizerCategory;
  }

  const handleSubmit = async () => {
	setLoading(true);
	try {
	  await form.validateFields();
	  const data = setEntityFromFields();
	  const result = await props.onSubmit(data);
	  if (result) props.onHide();
	} finally {
	  setLoading(false);
	}
  }

  return (
	<>
	  <DraggableModal
		title={props.fertilizerCategory.id === 0 ? t('handbooks.fertilizer_category.add_fertilizer_category') : t('handbooks.fertilizer_category.edit_fertilizer_category')}
		visible={props.show}
		onCancel={props.onHide}
		onSubmit={handleSubmit}
		submitLoading={loading}
	  >
		<Form
		  initialValues={{ remember: true }}
		  autoComplete="off"
		  layout="vertical"
		  form={form}
		>
		  <Form.Item
			label={ t('general.alias') }
			name={FormField.alias}
			rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
		  >
			<Input autoComplete="off" />
		  </Form.Item>
		  <Form.Item
			label={ t('general.nameKy') }
			name={FormField.nameKy}
			rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
		  >
			<Input autoComplete="off" />
		  </Form.Item>
		  <Form.Item
			label={ t('general.nameRu') }
			name={FormField.nameRu}
			rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
		  >
			<Input autoComplete="off" />
		  </Form.Item></Form>
	  </DraggableModal>
	</>
  )
}









